<template>
  <div>
    <div class="section1">
      <img :src="imgUrl" alt="">
      <div class="auBox">
        <p>{{isChinese ? cName : eName}}</p>
        <template v-if="cText">
          <p class="hasP">{{isChinese ? cText : eText}}</p>
        </template>
        <template v-if="dTextShow">
          <span class="innerBtnBox" @click="goto(dTextUrl)">
            {{isChinese ? dTextC : dTextE}}
          </span>
        </template>
      </div>


    </div>
  </div>
</template>
<script>
    export default {
      name: "topImgTemp",
      props:{
        imgUrl: String,
        cName: String,
        eName: String,
        cText: {
          type: String,
          required: false
        },
        eText: {
          type: String,
          required: false
        },
        dTextShow: {
          type: Blob,
          required: false
        },
        dTextUrl: {
          type: String,
          required: false
        },
         dTextC: {
          type: String,
          required: false
        },
         dTextE: {
          type: String,
          required: false
        }

      },
      data () {
        return {
          isChinese: undefined
        }
      },
      computed: {
        setCAE() {
          return this.$store.state.cAeSatus
        }
      },
      watch:{   //监听路由变化
        setCAE(newVal) {
          this.isChinese = newVal === 1 ? true : false
        },
      },
      created() {
        this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;
      },
      methods: {
        goto(url) {
          this.$router.push({path: url})
        }
      }
    }
</script>

<style scoped>
  img {
    width: 100%;
    height: 100%;
  }
  .section1 {
    position: relative;
    width: 100%;
    height: auto;
    /* height: 100vh; */
  }
  .auBox {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    flex-flow: column;
    font-size: 7rem;
  }
  .hasP {
    font-size: 3rem;
    margin-top: 0px;
  }
  .innerBtnBox {
    font-size: 15px;
    padding: 10px 30px;
    border: 1px solid white;
    cursor: pointer;
  }
 @media (max-width:750px) {
   .auBox {
     font-size: 30px;
   }
   .hasP{
     font-size: 20px;
     text-align: center;
     font-family: "Light";
   }

 }

</style>



// WEBPACK FOOTER //
// src/components/baseTemp/topImgTemp.vue